
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Mumbaitoalibaugcabservice() {



    const cardData =
    {
        keyword: 'Mumbai to Alibaug Cab Service',
        heading: 'Meghana Cab : Mumbai to Alibaug Cab Service ',
        headingDescription: 'Meghana Cab offers Mumbai to Alibaug Cab Service, providing a comfortable, safe, and scenic travel experience along the beautiful Konkan coastline. Covering a distance of around 95 kilometers, our professional chauffeurs ensure a smooth and timely ride, whether you’re traveling for a weekend getaway, beach holiday, or family retreat. Choose from our fleet of air-conditioned sedans, SUVs, and tempo travellers for a relaxing journey from Mumbai to Alibaug. Enjoy flexible pickup options, transparent pricing, and 24×7 customer support, making your trip stress-free and enjoyable. Book your Mumbai to Alibaug Cab with Meghana Cab and travel in comfort, style, and complete peace of mind.',


        top: 'Top Places to Visit in Alibaug with Meghana Cab',

"topPlaces": [
  {
    "title": "Alibaug Beach and Fort Viewpoint",
    "description": "Alibaug Beach is the heart of this charming coastal town, offering a sweeping view of the majestic Kolaba Fort standing tall amidst the Arabian Sea. The beach’s golden sands, horse rides, and gentle waves make it perfect for family outings and evening strolls. During low tide, visitors can even walk up to Kolaba Fort and explore its centuries-old walls and cannons, which once served as a Maratha naval base. The sunset from Alibaug Beach paints the sky in hues of orange and crimson, creating a picture-perfect moment. With food stalls, coconut vendors, and seagulls hovering above, this beach truly captures the essence of Alibaug’s coastal beauty and heritage."
  },
  {
    "title": "Kolaba Fort",
    "description": "Kolaba Fort is Alibaug’s most famous historical monument, standing proudly in the sea about 2 km from the shore. Built by Chhatrapati Shivaji Maharaj in the 17th century, this sea fort served as a strategic naval station protecting the Konkan coast. The fort houses ancient temples dedicated to Lord Ganesha and Mahishasura, along with carvings, freshwater wells, and cannons facing the ocean. During low tide, visitors can walk across the shallow waters to reach it, while high tide allows boat access. The fort’s stone architecture and panoramic sea views make it a must-visit for history lovers, photographers, and adventure seekers exploring Alibaug’s maritime past."
  },
  {
    "title": "Nagaon Beach",
    "description": "Nagaon Beach is one of the most popular beaches near Alibaug, known for its long stretch of soft sands, clear waters, and thrilling water sports. Visitors can enjoy parasailing, banana rides, and jet skiing, while the peaceful surroundings make it ideal for sunbathing or relaxing under palm trees. The beach is dotted with small resorts, homestays, and beach shacks offering fresh seafood and refreshing drinks. As evening approaches, the calm waves reflect the sunset like molten gold, providing a serene escape from city life. Nagaon’s balance of adventure and tranquility makes it a top choice for couples, families, and weekend travelers alike."
  },
  {
    "title": "Kihim Beach",
    "description": "Kihim Beach is a scenic paradise surrounded by dense coconut groves and lush greenery, making it one of Alibaug’s most picturesque coastal destinations. Its soft sands and shallow waters attract photographers and nature enthusiasts. Kihim is also famous for its unique flora and fauna—especially rare butterflies and birds that thrive in the nearby forests. Beach cottages and eco-resorts line the coast, providing a rustic yet comfortable stay experience. On clear mornings, one can see the Mumbai skyline across the Arabian Sea. With its unspoiled charm and soothing vibe, Kihim Beach offers a peaceful alternative to the busier beaches of Alibaug."
  },
  {
    "title": "Varsoli Beach",
    "description": "Varsoli Beach is a serene, less-crowded stretch of coastline located just a few kilometers from Alibaug town. Known for its cleanliness and calm waters, it’s an excellent spot for swimming, walking, or simply relaxing with loved ones. The beach is surrounded by tall palm trees, quaint cottages, and fishing boats gently anchored by the shore. Its tranquil ambiance makes it perfect for travelers seeking solitude away from tourist noise. The gentle sea breeze, rhythmic sound of waves, and sight of local fishermen at work add to the charm. Varsoli is often praised as one of Alibaug’s most peaceful and underrated beaches."
  },
  {
    "title": "Mandwa Beach and Jetty",
    "description": "Mandwa Beach serves as the main gateway to Alibaug for visitors traveling from Mumbai via ferry. The beach offers a beautiful panoramic view of the sea with the backdrop of distant city skylines. Mandwa has evolved into a popular hub for water sports like windsurfing, kayaking, and stand-up paddling. The Mandwa Jetty area also features trendy beachside cafes, seafood restaurants, and resorts offering stunning sunset views. With its blend of adventure and leisure, Mandwa is perfect for those who want a quick weekend escape from Mumbai — just a short ferry ride across the Arabian Sea yet worlds away in serenity and charm."
  },
  {
    "title": "Korlai Fort and Lighthouse",
    "description": "Perched on a hill near Revdanda, Korlai Fort offers panoramic views of the Arabian Sea and surrounding countryside. Built by the Portuguese in the 16th century, the fort features stone ramparts, old bastions, and remnants of a church that speak of its colonial past. The adjacent Korlai Lighthouse, still operational, offers visitors a guided view of the coastline from its observation deck. The gentle sea breeze, scenic cliffs, and peaceful surroundings make it an ideal spot for photographers and history buffs. Away from the crowds, Korlai Fort provides a tranquil escape into Alibaug’s lesser-known yet equally fascinating side."
  },
  {
    "title": "Revdanda Beach and Fort",
    "description": "Revdanda Beach is a pristine and less-explored gem located about 17 km from Alibaug. Its black sand, tall coconut trees, and quiet surroundings make it perfect for solitude seekers and photographers. The nearby Revdanda Fort, partly engulfed by nature, adds a mysterious charm with its ruined walls and moss-covered towers. Once a Portuguese stronghold, it now offers panoramic sea views and a glimpse into Goa’s early colonial influence on the Konkan coast. The sound of waves echoing through the fort ruins creates a magical ambiance. For travelers looking beyond the usual, Revdanda is a hidden treasure waiting to be explored."
  },
  {
    "title": "Kashid Beach",
    "description": "Kashid Beach, located about 30 km from Alibaug, is one of the cleanest and most beautiful beaches on the Konkan coastline. Framed by casuarina trees and rolling hills, it’s ideal for picnics, photography, and long scenic drives. The white sand and turquoise waters create postcard-perfect views, while activities like parasailing, ATV rides, and horse riding add excitement. The nearby Phansad Wildlife Sanctuary enhances the area’s natural charm. Whether you’re seeking adventure, a romantic getaway, or a quiet weekend retreat, Kashid Beach offers a blend of beauty and serenity that perfectly represents coastal Maharashtra."
  },
  {
    "title": "Kanakeshwar Forest and Temple",
    "description": "Located on a hilltop about 12 km from Alibaug, the Kanakeshwar Temple is dedicated to Lord Shiva and surrounded by dense forest. The climb of nearly 700 steps rewards visitors with breathtaking views of the Arabian Sea and lush valleys below. The temple complex also houses ancient idols, water tanks, and smaller shrines, exuding divine tranquility. The forest is rich in biodiversity and home to many species of birds and butterflies. The cool mountain air and sacred atmosphere make Kanakeshwar an excellent destination for both nature lovers and devotees seeking spiritual peace amid Alibaug’s natural beauty."
  }
],


        "services": [
    {
      "name": "Mumbai to Alibaug Cab",
      "description": "Book a comfortable Mumbai to Alibaug cab with Meghana Cab for your next coastal getaway. Enjoy a smooth and scenic drive along the Mumbai-Goa highway with our air-conditioned, well-maintained vehicles. Whether traveling solo, as a couple, or with family, our professional drivers ensure a safe and pleasant trip to Alibaug. Choose from Sedans, Ertiga, Innova, or Innova Crysta models, and experience doorstep pickup, transparent fares, and on-time service."
    },
    {
      "name": "Mumbai to Alibaug Taxi",
      "description": "Travel conveniently from Mumbai to Alibaug with Meghana Cab’s reliable taxi service. Perfect for weekend getaways or beach vacations, our taxis come equipped with modern amenities for your comfort. Enjoy 24/7 booking, flexible routes, and experienced drivers familiar with Alibaug’s routes and resorts. We provide both one-way and round-trip taxi options at competitive prices."
    },
    {
      "name": "Navi Mumbai to Alibaug Taxi Fare",
      "description": "Meghana Cab offers affordable taxi fares from Navi Mumbai to Alibaug, making your short coastal journey easy and economical. Choose from a range of vehicles like Sedans, SUVs, and luxury cars. Our fares are fully transparent, covering fuel, tolls, and driver allowances, ensuring you enjoy a budget-friendly and hassle-free travel experience."
    },
    {
      "name": "Mumbai to Alibaug Taxi Service",
      "description": "Meghana Cab provides the most trusted Mumbai to Alibaug taxi service for travelers seeking comfort and punctuality. Our drivers are courteous and knowledgeable about the local area, ensuring smooth navigation to your destination. Enjoy clean, air-conditioned taxis, flexible pickup timings, and affordable fares for all types of travelers — families, friends, or corporate clients."
    },
    {
      "name": "Taxi Fare from Mumbai to Alibaug",
      "description": "Get the best taxi fare from Mumbai to Alibaug with Meghana Cab. Our pricing is competitive and includes all necessary travel charges with no hidden costs. You can select from a variety of car types based on your group size and comfort requirements. Book online easily and get instant confirmation for a safe and enjoyable journey."
    },
    {
      "name": "Thane to Alibaug Taxi Fare",
      "description": "Travel from Thane to Alibaug with Meghana Cab’s dependable taxi service. Our affordable fares make coastal travel convenient and comfortable. Whether for leisure or business, enjoy smooth rides in AC vehicles driven by professional chauffeurs who ensure timely drop-offs and safety throughout your journey."
    },
    {
      "name": "Mumbai Airport to Alibaug Cab",
      "description": "Need a direct cab from Mumbai Airport to Alibaug? Meghana Cab provides airport pickup and drop services to Alibaug’s hotels and beaches. Enjoy a stress-free transition from your flight to your coastal stay with our punctual airport cabs. Our fleet includes Sedans, Ertiga, and Innova Crysta for individuals and families alike."
    },
    {
      "name": "Andheri to Alibaug Cabs",
      "description": "Meghana Cab offers safe and affordable cab services from Andheri to Alibaug. Perfect for travelers heading to weekend resorts, our air-conditioned vehicles and experienced drivers ensure a comfortable and efficient ride. Flexible departure timings and transparent fares make it the ideal choice for your Alibaug trip."
    },
    {
      "name": "Dadar to Alibaug Cabs",
      "description": "Book your Dadar to Alibaug cab with Meghana Cab for a smooth coastal journey. Our professional chauffeurs and well-maintained cars ensure a pleasant experience. Whether it’s a one-way drop or a round trip, we provide timely service, clean vehicles, and budget-friendly rates for all types of travelers."
    },
    {
      "name": "Mumbai Central to Alibaug Cab",
      "description": "Travel from Mumbai Central to Alibaug in comfort with Meghana Cab. Our service ensures on-time pickup, air-conditioned cars, and courteous drivers. Choose from multiple vehicle options — Sedan, Ertiga, or Innova — for a smooth and scenic ride along the coastal route. Ideal for family outings or leisure weekends."
    },
    {
      "name": "Borivali to Alibaug Cabs",
      "description": "Meghana Cab provides reliable Borivali to Alibaug cab services at affordable prices. With our comfortable AC cars and professional drivers, your journey from the suburbs to the beachside destination becomes enjoyable. Book one-way or round-trip options as per your travel schedule."
    },
    {
      "name": "Bandra to Alibaug Cab Booking",
      "description": "Book your Bandra to Alibaug cab easily with Meghana Cab for a relaxing weekend trip. Our drivers ensure a smooth, safe, and scenic drive via the coastal route. Enjoy comfort and convenience in our Sedans, SUVs, or Innova Crysta models, all available at transparent fares and flexible timings."
    },
    {
      "name": "Mumbai to Alibaug Innova Crysta",
      "description": "Travel luxuriously from Mumbai to Alibaug with Meghana Cab’s Innova Crysta service. Perfect for families and groups, the Crysta offers spacious interiors, smooth suspension, and top-notch comfort for long or short trips. Experience premium coastal travel with our professional drivers and flexible booking options."
    },
    {
      "name": "Mumbai to Alibaug Innova Cabs",
      "description": "Meghana Cab provides premium Innova cab services from Mumbai to Alibaug for travelers who value comfort and reliability. Our Innova fleet ensures ample space, AC comfort, and a smooth journey along the Mumbai-Alibaug highway. Ideal for family vacations, group trips, or corporate travel."
    },
    {
      "name": "Mumbai to Alibaug Ertiga Car Booking",
      "description": "Book an Ertiga cab from Mumbai to Alibaug with Meghana Cab for a comfortable and affordable ride. The Ertiga offers spacious seating, AC comfort, and great mileage for cost-effective travel. Suitable for families or small groups, our Ertiga service ensures a safe and enjoyable trip to Alibaug’s scenic beaches."
    },
    {
      "name": "Mumbai to Alibaug Sedan Cabs",
      "description": "Travel affordably from Mumbai to Alibaug with Meghana Cab’s Sedan taxi service. Ideal for solo travelers and couples, our Sedans offer comfort, AC convenience, and smooth handling for a peaceful drive to Alibaug. Enjoy budget-friendly fares and reliable service with timely pickups and drops."
    }
  ],
  "tableData": [
    ["Mumbai to Alibaug Cab", "Mumbai to Alibaug Taxi"],
    ["Navi Mumbai to Alibaug Taxi Fare", "Mumbai to Alibaug Taxi Service"],
    ["Taxi Fare from Mumbai to Alibaug", "Thane to Alibaug Taxi Fare"],
    ["Mumbai Airport to Alibaug Cab", "Andheri to Alibaug Cabs"],
    ["Dadar to Alibaug Cabs", "Mumbai Central to Alibaug Cab"],
    ["Borivali to Alibaug Cabs", "Bandra to Alibaug Cab Booking"],
    ["Mumbai to Alibaug Innova Crysta", "Mumbai to Alibaug Innova Cabs"],
    ["Mumbai to Alibaug Ertiga Car Booking", "Mumbai to Alibaug Sedan Cabs"]
  ],









"whychoose": [
    {
        "WhyChooseheading": "Reliable Mumbai to Alibaug Cab Service",
        "WhyChoosedescription": "Meghana Cab offers dependable and comfortable cab services from Mumbai to Alibaug, perfect for beach outings, weekend getaways, and family trips."
    },
    {
        "WhyChooseheading": "On-Time Pick-Up and Drop at Alibaug",
        "WhyChoosedescription": "We ensure punctual pick-up from anywhere in Mumbai and timely drop at your chosen destination in Alibaug, so your trip goes exactly as planned."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Coastal Travel",
        "WhyChoosedescription": "Our drivers are familiar with the Mumbai to Alibaug route, including scenic spots and ferry terminals, ensuring a smooth and pleasant ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy competitive cab fares with no hidden charges. Meghana Cab offers honest pricing, making your Mumbai to Alibaug trip budget-friendly."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Vehicles",
        "WhyChoosedescription": "All our cabs are regularly sanitized and come equipped with safety features like GPS, seat belts, and 24/7 emergency assistance."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability",
        "WhyChoosedescription": "Need an early morning pickup or late-night return from Alibaug? Meghana Cab is available round-the-clock to fit your travel schedule."
    },
    {
        "WhyChooseheading": "Customizable Travel Options",
        "WhyChoosedescription": "Choose from one-way, round-trip, or multi-stop packages as per your convenience. Plan your Alibaug visit exactly the way you want it."
    },
    {
        "WhyChooseheading": "Easy Booking with Full Support",
        "WhyChoosedescription": "Book your Mumbai to Alibaug cab quickly via our website or app. Our dedicated customer support team is always ready to assist you."
    }
]




























    }








const faqData = [
    {
        question: "How can I book a Mumbai to Alibaug cab with Meghana Cab?",
        answer: "You can book a Mumbai to Alibaug cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What types of cabs are available for Mumbai to Alibaug travel?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers depending on your group size and comfort preference."
    },
    {
        question: "Is one‑way service available from Mumbai to Alibaug?",
        answer: "Yes, we offer both one‑way and round‑trip cab services from Mumbai to Alibaug."
    },
    {
        question: "How long does the journey take from Mumbai to Alibaug by cab?",
        answer: "The trip is usually around **2 to 3 hours**, depending on traffic. :contentReference[oaicite:0]{index=0}"
    },
    {
        question: "What is the distance covered from Mumbai to Alibaug by road?",
        answer: "The distance is approximately **95‑100 km** by most road routes. :contentReference[oaicite:1]{index=1}"
    },
    {
        question: "What will the fare roughly be for a cab from Mumbai to Alibaug?",
        answer: "Fares vary with car type. For example, standard sedans may cost ~ ₹2,100‑₹2,500 for one way; SUVs more. :contentReference[oaicite:2]{index=2}"
    },
    {
        question: "Are tolls, taxes and parking included in the fare?",
        answer: "Tolls, state taxes, driver allowance etc. may be included or additional depending on the booking. Meghana Cab will clearly communicate these during booking."
    },
    {
        question: "Can I request stops or sightseeing en route to Alibaug?",
        answer: "Yes, you can request custom stops or breaks during the ride. Please mention this while booking."
    },
    {
        question: "Is night time travel available for the Mumbai to Alibaug route?",
        answer: "Yes, Meghana Cab operates 24/7, so you can schedule pickups/drop offs at late hours if required."
    },
    {
        question: "What payment options do you accept for Mumbai to Alibaug cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for all bookings."
    },
    {
        question: "How do I contact Meghana Cab to book or enquire about a Mumbai to Alibaug cab?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a cab with Meghana Cab from Mumbai to Alibaug. Very smooth ride, driver punctual, clean vehicle. Definitely worth the cost.”'
    },
    {
        name: 'Mrs. Nisha Patil',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great service! The trip was comfortable, and despite some traffic we reached Alibaug without any hassle. Meghana Cab truly values customer satisfaction.”'
    }
];















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Alibaug Cab Service",
  "description": "Book Mumbai to Alibaug cab service with Meghana Cabs. Reliable taxi fares from Mumbai, Navi Mumbai, Thane, and airport transfers. Comfortable Innova, Crysta, Ertiga, and sedan cab bookings for a smooth ride to Alibaug.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "2950"
  }
};




    return (
        <div>

<Helmet>
  <title>Mumbai to Alibaug Cab Service | Reliable Taxi & Car Rental @ Meghana Cabs</title>
  <meta
    name="description"
    content="Get reliable Mumbai to Alibaug cab service with Meghana Cabs. Affordable taxi fares, Innova, Crysta, Ertiga, and sedan cabs from Mumbai, Navi Mumbai, Thane, and airport. Book now for a smooth ride."
  />
  <meta
    name="keywords"
    content="Mumbai to Alibaug Cab, Mumbai to alibaug taxi, Navi mumbai to alibaug taxi fare, mumbai to alibaug taxi service, taxi fare from mumbai to alibaug, thane to alibaug taxi fare, mumbai airport to alibaug cab, Andheri to Alibag cabs, Dadar to Alibaug Cabs, mumbai central to alibaug cab, borivali to alibaug Cabs, bandra to alibaug cab booking, mumbai to alibaug innova crysta, mumbai to alibaug innova cabs, mumbai to alibaug ertiga car booking, mumbai to alibaug Sedan Cabs"
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>






            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoalibaugcabservice;